let workflowSessionId;
get("/app/workflow/workflowSessionId", {}).then(data => { workflowSessionId = data })

async function handleWorkflowMessage({body}) {
    const [action, id, session] = strSplit(body, ";", 5);
    if (session !== workflowSessionId) return;
    const panel = document.getElementById("workflowPanelContent" + id);
    // all three actions trigger a re-render if the panel is open
    if (panel) $(panel).load(`/${appLocation}workflow/instances/${id}/panel`);
    // if it is not open, and the action was to open it, do so
    if (action === "open" && isActiveTab && !panel) openWorkflowPanel(id);
    // if the action is close, and there is a panel, then we close the panel after a delay
    if (action === "close" && panel) {
        setTimeout(() => panel.closest('.jsPanel')?.remove(), 5000);
    }
}

function triggerWorkflow(workflowId) {
    const buttonId = "triggerWorkflowButton" + workflowId;
    // contains either the text of the button, or null if no button was found
    const oldButtonText = document.getElementById(buttonId) && setButtonInWaitingMode(buttonId);
    const patient = $('#currentPatientId').attr("value");
    $.post(`/${appLocation}workflow/trigger`, {workflowId, patient});
    // if non-null (meaning we had a button) delay for a sec to avoid multi-triggering the button
    if (oldButtonText) setTimeout(() => {
        wakeButtonFromWaitingMode(buttonId, oldButtonText);
        actionSuccess();
    }, 1000);
}

function openWorkflowPanel(id) {
    const panelElement = document.getElementById("workflowPanelContent" + id);
    if (panelElement) return get(`/${appLocation}workflow/instances/${id}/panel`).then(it => panelElement.innerHTML = it);
    const panel = jsPanel.create({
        headerTitle: "Workflow",
        closeOnEscape: false,
        headerLogo: '<span style="padding:10px" class="glyphicon glyphicon-list" aria-hidden="true"></span>',
        contentSize: {width: "300px", height: "500px"},
        borderRadius: 3,
        resizeit: {disable: true},
        headerControls: {maximize: "remove"},
        content: function () {
            const content = $(`<div id="workflowPanelContent${id}" style="display: contents">`);
            $(this.content).append(content);
            content.load(`/${appLocation}workflow/instances/${id}/panel`);
        },
        footerToolbar: '<div class="pull-right btn-group-xs"><button class="btn btn-default">Schließen</button></div>',
        theme: "#f2f2f2",
    })
    panel.footer.querySelector(".btn").addEventListener("click", () => panel.close())
}

function reloadWorkflowInstanceList() {
    $("#workflowInstanceList").load(`/${appLocation}workflow/instances/list`)
}

/**
 * executes a workflow action
 * @param workflowId the id of the workflow to act upon
 * @param action the action to execute
 * @param data optional data (only needed for resume action)
 * @param event an optional event of which to stop propagation
 * @returns {Promise<*>} the success (a boolean) of the action
 */
async function workflowInstanceAction(workflowId, action, data = {}, event = null) {
    if (event) {
        event.stopPropagation();
        // since the same action is contextually dangerous or not, and the html reflects that state, we just use that info
        const classes = [...event.currentTarget.classList];
        const isDangerous = classes.includes("btn-danger") || classes.includes("btn-warning");
        if (isDangerous && !await customConfirmAsync("Sind Sie sicher?", "Diese Aktion kann nicht rückgängig gemacht werden.")) {
            return;
        }
    }

    // wrap the data, which lets uns send any type of primitive with less issues. this gets unwrapped by the endpoint automatically
    const payload = { data: data !== undefined ? data : null }
    const success = await post(`/${appLocation}workflow/instances/${workflowId}/${action}`, payload);

    if (event) {
        const target = event.target;
        const list = document.getElementById("workflowInstanceList");
        // if the action was trigger from within the list
        if (success && list.contains(target)) reloadWorkflowInstanceList();
    }

    return success
}

async function doctorWorkflowAction(action) {
    const isDangerous = ["abortAll"].includes(action);
    if (isDangerous && !await customConfirmAsync("Sind Sie sicher?", "Diese Aktion kann nicht rückgängig gemacht werden.")) {
        return;
    }
    const staus = await $.post(`/${appLocation}doctorWorkflowAction/${action}`);
    if (staus === "success") {
        actionSuccess();
        reloadWorkflowInstanceList();
    } else actionFail(staus);
}

const WorkflowManagement = {
    workflowId: null, healthCareProviderBloodhound: null, workflowBloodhound: null,
    workflowName: function (workflow) {
        let {id, effectiveName, healthCareProvider, effectiveShortcut} = workflow;
        const owner = healthCareProvider?.fullName || "template";
        const shortcut = effectiveShortcut ? ` (${effectiveShortcut})` : ""
        return `(${id}) ${effectiveName}${shortcut} - ${owner}`
    },
    healthCareProviderName: function ({ id, fullName }) {
        return fullName === "jeder" ? "jeder" :`(${id}) ${fullName}`;
    },
    initialize: async function () {
        if (!WorkflowManagement.workflowBloodhound) {
            WorkflowManagement.workflowBloodhound = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 100,
                remote: {
                    url: `/${appLocation}admin/workflows/list?q=%QUERY`,
                    wildcard: '%QUERY'
                }
            });
            WorkflowManagement.workflowBloodhound.initialize();
        }
        $('#workflowsTypeahead').typeahead({hint: true, highlight: true, minLength: 1}, {
            name: 'workflows',
            display: WorkflowManagement.workflowName,
            source: WorkflowManagement.workflowBloodhound.ttAdapter(),
            templates: {
                suggestion: function (workflow) {
                    return `<div class="ml-2">${WorkflowManagement.workflowName(workflow)}</div>`;
                }
            }
        })
            .on('focus', function () {
                $(this).select();
            })
            .on('typeahead:selected', WorkflowManagement.loadWorkflow);
        if (!WorkflowManagement.healthCareProviderBloodhound) {
            WorkflowManagement.healthCareProviderBloodhound = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 100,
                remote: {
                    url: `/${appLocation}admin/workflow/findPerson?query=%QUERY`,
                    wildcard: '%QUERY'
                }
            });
            WorkflowManagement.healthCareProviderBloodhound.initialize();
        }
    },
    update: function (setting, value) {
        $.post(`/${appLocation}admin/workflow/update`, {
            workflowId: WorkflowManagement.workflowId,
            setting, value
        });
    },
    loadWorkflow: async function (event, {id}) {
        WorkflowManagement.workflowId = id
        const container = document.getElementById("workflowManagement");
        container.innerHTML = await $.get(`/${appLocation}admin/workflow/ui/settings/${id}`);
        container.style.display = "block";
        initJsonEditor(document.getElementById("workflowActions"), {
            schema: await $.get(`/${appLocation}admin/workflow/ui/schema/step`),
            templates: [
                {
                    text: "Schritt",
                    title: "neuen Schritt einfügen",
                    className: 'jsoneditor-type-object',
                    field: 'StepTemplate',
                    value: {
                        action: '',
                        parameters: {},
                        result: '',
                        condition: '',
                        expression: ''
                    }
                }
            ]
        });
        initJsonEditor(document.getElementById("workflowInitialValues"));

        const templateTypeahead = $('#templateTypeahead').typeahead({hint: true, highlight: true, minLength: 1}, {
            name: 'workflows', display: WorkflowManagement.workflowName,
            source: WorkflowManagement.workflowBloodhound.ttAdapter(),
            templates: {
                suggestion: function (workflow) {
                    return `<div class="ml-2">${WorkflowManagement.workflowName(workflow)}</div>`;
                }
            }
        })
            .on('focus', function () {
                $(this).select();
            })
            .on('typeahead:selected', function (event, suggestion) {
                $('#template').val(suggestion.id);
            });
        const templateId = $('#template').val();
        if (templateId) {
            const matches = await $.get(`/${appLocation}admin/workflows/list?q=${encodeURIComponent(templateId)}`);
            const exactMatch = matches.find(item => String(item.id) === String(templateId));
            if (exactMatch) {
                templateTypeahead.typeahead('val', WorkflowManagement.workflowName(exactMatch));
            }
        }

        const healthCareProviderTypeahead = $('#healthCareProviderTypeahead')
            .typeahead({hint: true, highlight: true, minLength: 1}, {
                name: 'workflows', display: WorkflowManagement.healthCareProviderName,
                source: WorkflowManagement.healthCareProviderBloodhound.ttAdapter(),
                templates: {
                    suggestion: function ({id, fullName}) {
                        return `<div class="ml-2">(${id}) ${fullName}</div>`;
                    }
                }
            })
            .on('focus', function () {
                $(this).select();
            })
            .on('typeahead:selected', function (event, suggestion) {
                $('#healthCareProvider').val(suggestion.id);
            });
        const healthCareProviderId = $('#healthCareProvider').val();
        if (healthCareProviderId) {
            const query = encodeURIComponent(healthCareProviderId);
            const matches = await $.get(`/${appLocation}admin/workflow/findPerson?query=${query}`);
            const exactMatch = matches.find(item => String(item.id) === String(healthCareProviderId));
            if (exactMatch) {
                healthCareProviderTypeahead.typeahead('val', WorkflowManagement.healthCareProviderName(exactMatch));
            }
        }

        $('#workflowForm').submit(async function () {
            const buttonText = setButtonInWaitingMode("workflowFormSubmit");
            $.post($(this).attr('action'), $(this).serialize())
                .then(function () {
                    actionSuccess();
                    $("#workflowManagement").hide()
                    $("#workflowsTypeahead").val('').focus();
                })
                .catch(function (error) {
                    actionFail(error.status);
                    wakeButtonFromWaitingMode("workflowFormSubmit", buttonText);
                });
            return false
        });
    },
    findInput: function (container, step, names, mapping = (input) => input?.value) {
        if (Array.isArray(names)) {
            names.forEach(it => WorkflowManagement.findInput(container, step, it, mapping))
        } else {
            const answer = mapping(container.querySelector(`input[name='${names}']`));
            if (answer) step[names] = answer;
        }
    },
}

/** collection of actions taken within the ui that resume a workflow */
const WorkflowUIActions = {
    navigate: function (instanceId, target, type = null) {
        workflowInstanceAction(instanceId, 'resume')
        switch (type) {
            case "href":
                location.href = target;
                return;
            case "_blank":
                window.open(target, "_blank");
                return;
            default:
                router.navigate(`/${appLocation}${target}`, {trigger: true});
        }
    },
    loadDocumentToSign: async function (workflowInstanceId, documentId) {
        return new Promise(function (resolve, reject) {
            loadDocumentToSign(documentId, resolve, reject);
        }).then(data => workflowInstanceAction(workflowInstanceId, 'resume', data));
    },
    sendDocumentWithDaMe: function (workflowId, documentId) {
        sendDameMessageModal(documentId, workflowId)
    },
    sendDocumentWithMediprimeApp: function (workflowId, patientId, patientName, documentId) {
        openMediprimeAppMessageModal(patientId, patientName, [documentId], undefined, false, workflowId)
    }
}

